export interface Assets {
  pages: PageAssetGroup[];
  plans: PlanAssetGroup[];
  features: FeatureAssetGroup[];
  services: any[];
}

export interface Asset {
  urlPath: string;
  imageAltText: string;
  type: string;
  audioUrl?: string;
}

export interface FeatureAssetGroup {
  name: string;
  code?: string;
  featureAssets: FeatureAsset[];
}

export interface FeatureAsset {
  id: string;
  isVehicleBrandSpecific: boolean;
  brands: BrandAsset[];
}

export interface BrandAsset {
  brand: string;
  assets: Asset[];
}

export interface PlanAssetGroup {
  name: string;
  planAssets: PlanAsset[];
}

export interface PlanAsset {
  id: string;
  assets: Asset[];
}

export interface PageAssetGroup {
  pageName: string;
  generalAssets: GeneralAsset[];
}

export interface GeneralAsset {
  id: string;
  assets?: Asset[];
  isVehicleBrandSpecific?: boolean;
  brands?: BrandAsset[];
}

export enum AssetType {
  Image = 'IMAGE',
  MobileImage = 'MOBILE_IMAGE'
}
